import {Injectable} from '@angular/core';
import {EnvironmentConfig} from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiLocationService {

  public getLocation() {
    let apiLocation: string;
    if (window.location.hostname === 'localhost') {
      apiLocation = EnvironmentConfig.PortalSettings.apiLocation;
    } else {
      apiLocation = window.location.protocol + '//' + window.location.hostname;
    }
    return apiLocation;
  }

}
